<template>
  <SlideSidebarContainer>
      <span slot="title">Histórico de cursos</span>

      <CourseHistoryList />
  </SlideSidebarContainer>
</template>


<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import CourseHistoryList from '@/components/course/course-history/CourseHistoryList'

  export default {
    components: {
      SlideSidebarContainer,
      CourseHistoryList,
    }
  }
</script>